// /Import Mixpanel SDK
import mixpanel from "mixpanel-browser";

export default defineNuxtPlugin((nuxtApp) => {
   // Near entry of your product, init Mixpanel
   mixpanel.init(nuxtApp.$config.public.mixpanel.token, {
      debug: !import.meta.dev,
      ignore_dnt: true,
      track_pageview: false,
      persistence: "localStorage",
   });

   nuxtApp.provide("mixpanel", mixpanel);
});
